module.exports = __webpack_public_path__ + "img/dreamCatcher.0886739f.png";